import { Alert, Button, FormHelperText, LinearProgress, Stack } from '@mui/material'
import { useFormikContext } from 'formik'
import { useEffect } from 'react'
import { useIntegrationsAccess } from '../store/integrations-access'

type SaveStatus = { type: 'success' } | { type: 'error'; message: string } | null

export function FormSaveControls() {
  const { isSubmitting, status, dirty, resetForm } = useFormikContext<unknown>()
  const saveStatus = status as SaveStatus
  const { canEdit } = useIntegrationsAccess()

  useEffect(() => {
    if (!dirty) return
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      e.returnValue = ''
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [dirty])

  return (
    <>
      {isSubmitting && <LinearProgress sx={{ mt: 1 }} />}
      {!isSubmitting && saveStatus?.type === 'error' && (
        <Alert severity="error" role="alert" sx={{ mt: 1 }}>
          {saveStatus.message}
        </Alert>
      )}
      {!isSubmitting && !dirty && saveStatus?.type === 'success' && <FormHelperText sx={{ color: 'success.main' }}>Saved</FormHelperText>}
      <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mt: 1 }}>
        {canEdit && (
          <>
            <Button type="button" variant="outlined" onClick={() => resetForm()} disabled={!dirty || isSubmitting}>
              Clear changes
            </Button>
            <Button type="submit" variant="contained" disabled={!dirty || isSubmitting}>
              Save
            </Button>
          </>
        )}
      </Stack>
    </>
  )
}

export { FormSaveControls as SaveStatusIndicator }
